// @ts-nocheck
import { YStack } from 'tamagui';

import {
  Header,
  Hero,
  SearchDemo,
  Comparison,
  Apps,
  HowItWorks,
  Security,
  AISection,
  Pricing,
  CTASection,
  Footer,
} from '../components/landing';

export default function LandingPage() {
  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />
      <Hero />
      <SearchDemo />
      <Comparison />
      <Apps />
      <HowItWorks />
      <Security />
      <AISection />
      <Pricing />
      <CTASection />
      <Footer />
    </YStack>
  );
}
